"use client";

import { useState } from "react";
import { Button, useToast } from "@boostdev/design-system-components/client";
import { useClientTranslation } from "@/lib/i18n/client";
import css from "./AddToCartButton.module.css";

export interface AddToCartButtonProps {
  onAdd: () => Promise<void>;
  disabled?: boolean;
  locale: string;
}

export function AddToCartButton({
  onAdd,
  disabled = false,
  locale,
}: AddToCartButtonProps): React.ReactElement {
  const { t } = useClientTranslation(locale, "shop");
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const handleClick = async (): Promise<void> => {
    setLoading(true);
    try {
      await onAdd();
      showToast(t("product.added"), "success");
    } catch {
      showToast(t("product.addError"), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={css.wrapper}>
      <Button
        type="button"
        disabled={disabled || loading}
        onClick={handleClick}
      >
        {t("product.addToCart")}
      </Button>
    </div>
  );
}
